import Cookies from "js-cookie";

export const isAuthenticated = () => Cookies.get("wpm-lightpole-username") && Cookies.get("wpm-lightpole-token");

export const createSession = (token, username, role, email) => {
    Cookies.set("wpm-lightpole-username", username, { expires: 30 }, { secure: true });
    Cookies.set("wpm-lightpole-token", token, { expires: 30 }, { secure: true });
    Cookies.set("wpm-lightpole-role", role, { expires: 30 }, { secure: true });
    Cookies.set("wpm-lightpole-email", email, { expires: 30 }, { secure: true });
    // Cookies.set("wpm-lightpole-userid", userid, { expires: 30 }, { secure: true });
};
export const logout = () => {
    Cookies.remove("wpm-lightpole-username");
    Cookies.remove("wpm-lightpole-token");
    Cookies.remove("wpm-lightpole-role");
    Cookies.remove("wpm-lightpole-email");
    // eslint-disable-next-line no-restricted-globals
    location.reload();
};

export const getUserName = () => Cookies.get("wpm-lightpole-username") || "";

export const getEmail = () => Cookies.get("wpm-lightpole-email") || "";

export const getRole = () => Cookies.get("wpm-lightpole-role") || "";
